/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appL7HeadersTextareaValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: L7HeadersTextareaValidationDirective, multi: true }]
})

export class L7HeadersTextareaValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return httpHeaderValidation(control);
    }
}

/**
 * Validates if a string is a valid HTTP header value according to RFC 7230
 * @param control
 * @returns {any}
 */
export function httpHeaderValidation(control: any): any {
    const value: string = control?.value?.trim();

    // This regex validates HTTP header values per RFC 7230
    // It allows:
    // - Visible ASCII chars (33-126, excluding DEL)
    // - Space (32)
    // - Horizontal tab (9)
    const headerValueRegex = /^[\t\x20-\x7E]*$/;

    return headerValueRegex.test(value)
        ? null
        : { 'textareaValidation': 'headers_invalid_text' };
}
